import React, { useState, useEffect, useLayoutEffect } from "react";
import Modal from "components/UI/Modal/Modal";
import { InsertModal, UpdateModal, DeleteModal } from "./Actions";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { routeInfo, userCredentials } from "recoilState/GlobalState";
import { HeaderButton } from "components";
import Add from "@mui/icons-material/Add";
import Cached from "@mui/icons-material/Cached";
import EditOutlined from "@mui/icons-material/EditOutlined";
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import { Buttons } from "components";
import { ACTIONS } from "consts/Actions";
import { conveniosTitles as titles } from "consts/titulos-de-tablas";
import { labelDeLey } from "consts/leyes";
import styles from "styles/pages/Pages.module.scss";
import { useService, puedeEditarServicio } from "components/route/ServiceRoute";
import XGrid from "components/UI/Grid/XGrid";
import { RNHConvenioGet } from "services/services-mia/programa-salud/personal/RNHConvenioGet";

export default function RegimenesHorario() {
  const credentials = useRecoilValue(userCredentials);
  const setRoute = useSetRecoilState(routeInfo);
  const [modalDetails, setModalDetails] = useState({ isOpen: false });
  const [loading, setLoading] = useState(false);
  const [convenios, setConvenios] = useState([]);
  const [rowSelected, setRowSelected] = useState({ status: false, row: {} });
  const { service } = useService();

  const getConvenios = async () => {
    setConvenios([]);
    setRowSelected({ status: false, row: {} });
    setLoading(true);
    const { data: result } = await RNHConvenioGet(credentials);
    const newRows = result[0]?.rnhConvenioId ? result?.map((data) => {
      return {
        id: data.rnhConvenioId,
        cod: data.rnhConvenioCod,
        ley: labelDeLey(data.rnhConvenioLey),
        leyCod: data.rnhConvenioLey,
        cargaSemanal: data.rnhConvenioCargaSemanal,
        version: data.rnhConvenioVersion,
      };
    }) : []
    setConvenios(newRows);
    setLoading(false);
  }
  const closeModal = () => {
    setModalDetails({ isOpen: false });
  };
  const handleClick = ({ procede, title }) => {
    setModalDetails({ procede, title, isOpen: true });
  };

  useEffect(() => {
    getConvenios()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useLayoutEffect(() => {
    setRoute({
      wordKey: `Regímenes Horario - Programa Salud RN`
    })
  }, [service.servicioNombre, setRoute])

  return (
    <main className={styles.main}>
      <Modal
        size={modalDetails.procede === ACTIONS.DELETE ? 'sm' : 'md'}
        open={modalDetails.isOpen}
        title={modalDetails.title}
        onClose={closeModal}
      >
        {modalDetails.procede === ACTIONS.UPDATE && (
          <UpdateModal
            convenio={rowSelected.row}
            updateList={getConvenios}
            closeModal={closeModal}
          />
        )}
        {modalDetails.procede === ACTIONS.DELETE && (
          <DeleteModal
            row={rowSelected.row}
            servicio={service}
            updateList={getConvenios}
            closeModal={closeModal}
            setterRowSelected={setRowSelected}
          />
        )}
        {modalDetails.procede === ACTIONS.INSERT && (
          <InsertModal
            servicio={service}
            updateList={getConvenios}
            closeModal={closeModal}
          />
        )}
      </Modal>
      <div className={styles["filters-actions-right"]}>
        <Buttons>
          <HeaderButton
            text={"Actualizar"}
            onClick={() => { getConvenios() }}
            disabled={rowSelected.row.id || false}
          >
            <Cached />
          </HeaderButton>
          <HeaderButton
            text={"Nuevo Régimen Horario"}
            handleClick={handleClick}
            data={{
              title: "Nuevo Régimen Horario",
              procede: ACTIONS.INSERT
            }}
            disabled={rowSelected.row.id || service.servicioPermiso !== 'E'}
          >
            <Add />
          </HeaderButton>
          <HeaderButton
            text={"Modificar Régimen Horario"}
            handleClick={handleClick}
            data={{
              title: "Modificar Régimen Horario",
              procede: ACTIONS.UPDATE
            }}
            disabled={!puedeEditarServicio(service) || (!rowSelected.row.id)}
          >
            <EditOutlined />
          </HeaderButton>
          <HeaderButton
            text={"Eliminar Régimen Horario"}
            handleClick={handleClick}
            data={{
              title: "Eliminar Régimen Horario",
              procede: ACTIONS.DELETE
            }}
            disabled={!puedeEditarServicio(service) || (!rowSelected.row.id)}
          >
            <DeleteOutlineRoundedIcon />
          </HeaderButton>
        </Buttons>
      </div>
      <div className={styles.container}>
        <XGrid
          rows={convenios}
          titles={titles}
          loading={loading}
          secondarySelected={rowSelected}
          setSecondarySelected={setRowSelected}
        />
      </div>
    </main>
  );
}